import { BLOG_LIKES } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = BLOG_LIKES;
export const getDefinition = (staticsUrl, t) => ({
    ...BLOG_LIKES,
    installLocation: InstallLocation.Profile,
    social: true,
    numbers: {
        key: 'likesCount',
        default: 0,
    },
    method: 'addSection',
    urlOverride: 'blog-likes',
    menuOrder: 2,
    page: {
        name: t('member-pages.likes.name'),
        shortDescription: t('member-pages.likes.short-description'),
        description: formatDescription({
            text: t('member-pages.likes.description.text'),
            bulletPoints: [
                t('member-pages.likes.description.bullet-point-1'),
                t('member-pages.likes.description.bullet-point-2'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/blog-icon.png`,
        origin: t('member-pages.origin'),
        isNew: false,
        screenshots: [
            `${staticsUrl}assets/images/blog-likes/blog-likes.png`,
            `${staticsUrl}assets/images/blog-likes/mobile-blog-likes.png`,
        ],
    },
});
//# sourceMappingURL=blog-likes.js.map